import cloneDeep from 'lodash/cloneDeep'

import { get } from 'utils/lodash'
import { fixContactLocationAssociation } from 'utils/form-body'
import { isTaxExempt } from 'data/customer/billingDetailsSelector'
import { getAssociations } from 'components/customers/edit/utils'
import { createDateFromString, formatDateToFEFormatDateFns } from 'utils/date'

const INITIAL_PO_STATE = { customerPurchaseOrder: false, po: '', maxPoAmount: '' }
const INITIAL_TAX_STATE = { taxExemptEnable: false, taxExempt: '' }

export const getExistingCustomerInfo = customerDetails => {
  const exitingContacts = cloneDeep(get(customerDetails, 'contacts', [])).map(contact => {
    const { associatedLocations } = getAssociations(customerDetails, contact.id)
    return { ...contact, associatedLocations, associatedWithLocation: associatedLocations.length > 0 }
  })

  return {
    contacts: fixContactLocationAssociation(exitingContacts),
    tags: get(customerDetails, 'tags', []).map(tag => tag.id),
    csr: get(customerDetails, 'csr.id', null),
  }
}

export const getPOAndTaxInfo = customerDetails => {
  const accountBilling = get(customerDetails, 'accountBilling', {})
  const po = get(accountBilling, 'po', '')
  const maxPoAmount = get(accountBilling, 'maxPoAmount', '')
  const taxExempt = accountBilling?.taxExempt
  let poInfo = INITIAL_PO_STATE
  let taxInfo = INITIAL_TAX_STATE
  const contractExpirationDate = get(customerDetails, 'contractExpirationDate')
  const contractExpirationEnable = !!contractExpirationDate
  const formattedContractExpirationDate =
    contractExpirationEnable && typeof contractExpirationDate === 'string'
      ? formatDateToFEFormatDateFns(createDateFromString(contractExpirationDate))
      : null

  if (po || maxPoAmount) {
    poInfo = { customerPurchaseOrder: true, po, maxPoAmount }
  }

  // Empty string is a valid case
  if (isTaxExempt(taxExempt)) {
    taxInfo = { taxExemptEnable: true, taxExempt }
  }

  return {
    ...poInfo,
    ...taxInfo,
    contractExpirationEnable,
    ...(contractExpirationEnable && { contractExpirationDate: formattedContractExpirationDate }),
  }
}

export const getEditAccountModel = customerDetails => {
  const contractExpirationDate = get(customerDetails, 'contractExpirationDate')
  const contractExpirationEnable = !!contractExpirationDate
  const formattedContractExpirationDate =
    contractExpirationEnable && typeof contractExpirationDate === 'string' ? createDateFromString(contractExpirationDate) : null
  return {
    id: get(customerDetails, 'id'),
    accountName: get(customerDetails, 'accountName', ''),
    billingAddress: get(customerDetails, 'billingAddress', {}),
    // echoed unchanged so an update that leaves the unit alone passes the backend's equality guard
    businessUnitId: get(customerDetails, 'businessUnitId', null),
    // locked once the account has payment history or saved methods; default to locked when unknown
    businessUnitLocked: get(customerDetails, 'businessUnitLocked', true),
    tags: get(customerDetails, 'tags', []),
    accountBilling: {
      id: get(customerDetails, 'accountBilling.id'),
      billingProfileId: get(customerDetails, 'accountBilling.billingProfile.id'),
      receivesPrintedCopy: get(customerDetails, 'accountBilling.receivesPrintedCopy', false),
      ...getPOAndTaxInfo(customerDetails),
    },
    contractExpirationEnable,
    ...(contractExpirationEnable && { contractExpirationDate: formattedContractExpirationDate }),
  }
}
